import React, { useState } from 'react';
import './App.css';
//import logo from './PAGE LOGO.png';
import logo from './page-industries-ltd.png';
//import logo from './pagelogo.png';
//import privatecollege from './PrivateCollegeBanner.png';
import privatecollege from './ImageScholarshipPvt.png';
import img1 from './img4.jpg';
import img5 from './img6.jpg';
import img6 from './image.png';
import img7 from './2503000335.png'


function App() {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [isScholarshipOpen, setIsScholarshipOpen] = useState(false);
  const [isApplyOpen, setIsApplyOpen] = useState(false);
  const [isHearBackOpen, setIsHearBackOpen] = useState(false);
  const [isCheckStatusOpen, setIsCheckStatusOpen] = useState(false);
  const [isNeedHelpOpen, setIsNeedHelpOpen] = useState(false);
  const [language, setLanguage] = useState<"en" | "kn">("en");
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const Scholarshiplink = process.env.REACT_APP_SCHOLARSHIPLINK;
  const ScholarshiplinkPriv = process.env.REACT_APP_SCHOLARSHIPLINKPRIVATE;
  const mapLink = process.env.REACT_APP_MAPLINK;
  const applicationStatus = process.env.REACT_APP_APPSTATUS;
  const retreiveConsent = process.env.REACT_APP_RETREIVECONSENT;
  const COLLEGELOGIN = process.env.REACT_APP_SCHOLARSHIPREGCOLLEGELOGIN;
  const PRIVATESTUDENT = process.env.REACT_APP_SCHOLARSHIPLINKPRIVATECOLLEGESTUDENT;

  const translations = {
    en: {
      header: "PAGE SCHOLARSHIP PROGRAM",
      headerSpan: "PART OF CSR INITIATIVE",
      applyNow: "APPLY FOR GOVT COLLEGE STUDENTS",
      RegisteredCollegeLogin: "REGISTERED COLLEGE LOGIN",
      PrivateCollegeRegistration: "APPLY FOR PRIVATE COLLEGE STUDENTS",
      applyNowPrivate: "PRIVATE COLLEGE REGISTRATION",
      applicationStatus: "APPLICATION STATUS",
      info: "INFO",
      unlockPotential: "Unlock Potential",
      futureWaiting: "Your future is waiting - grab it with both hands!",
      successRate: "Success Rate",
      happyStudents: "Happy Students",
      scholarshipsAwarded: "Scholarships Awarded",
      scholarshipProgram: "PAGE SCHOLARSHIP PROGRAM",
      whatScholarships: "What scholarships are available?",
      howToApply: "How do I apply for scholarships?",
      hearBack: "When Will I hear back?",
      checkStatus: "Can I check my Application Status?",
      needHelp: "What If I need help?",
      getInTouch: "Get in Touch Now!",
      namePlaceholder: "Name",
      emailPlaceholder: "Email",
      phonePlaceholder: "Phone",
      messagePlaceholder: "Message",
      sendIt: "Send It!",
      contactUs: "Contact Us",
      address: "Address: Page Industries Ltd, Umiya Business Bay - Tower - 1, 7th Floor, Cessna Business Park, Kadubeesanahalli, Varthur Hobli, Bengaluru- 560103.",
      phone: "Phone: 080-49454545 (Mob) / +91-6364455888",
      email: "Email: PageScholarship.Support@jockeyindia.com",
      workingHours: "Working Hours: Mon-Fri: 9am - 5pm",
      footer: "Page Industries Ltd. All rights reserved.",
      dontMiss: "Don't Miss Out!",
      chanceFunding: "Grab your chance at funding your dreams today!",
      coursesFor: "Support qualified students who have passed 10th standard and aspiring for",
      coursesListPre: "PUC (Science, Arts & Humanities, Commerce)",
      coursesListDip: "Diploma (Polytechnic)",
      coursesListITI: "ITI",
      coursePara: "Para Medical",
      applyInstructions: "Applying is as easy as pie! Just fill out our online form, sprinkle in some magic, and hit submit. We'll take care of the rest!",
      hearBackInstructions: "You can expect updates within a few weeks!!!",
      checkStatusInstructions: "Absolutely! Just click the Check Application Status button and unleash your inner detective. We’ll reveal all!",
      helpInstructions: "Need a hand? Our team is just a click away! Reach out, and we’ll guide you through the maze of scholarships.",
      home: "Home",
      about: "About",
      apply: 'HOW TO APPLY',
      retreiveConsent: 'Retrieve Consent',
      faq: 'FAQ',
      PAGE_TnC_Privacy: 'T&C',
      PAGE_Privacy_Notice: 'PRIVACY_NOTICE',
      LastDateToApply: '“PAGE SCHOLARSHIP IS OPEN FOR PRIVATE COLLEGES”',
    },
    kn: {
      header: "ಪೇಜ್ ವಿದ್ಯಾರ್ಥಿವೇತನ ಕಾರ್ಯಕ್ರಮ",
      headerSpan: "ಸಿಎಸ್ಆರ್ ಉಪಕ್ರಮದ ಭಾಗ",
      //applyNow: "ಈಗ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
      applyNow: "ಸರ್ಕಾರಿ ಕಾಲೇಜು ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
      RegisteredCollegeLogin: "ನೋಂದಾಯಿತ ಕಾಲೇಜು ಲಾಗಿನ್",
      PrivateCollegeRegistration: "ಖಾಸಗಿ ಕಾಲೇಜು ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
      applyNowPrivate: "ಖಾಸಗಿ ಕಾಲೇಜು ನೋಂದಣಿ",
      applicationStatus: "ಅರ್ಜಿಯ ಸ್ಥಿತಿ",
      info: "ಮಾಹಿತಿ",
      unlockPotential: "ಸಾಮರ್ಥ್ಯವನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಿ",
      futureWaiting: "ನಿಮ್ಮ ಭವಿಷ್ಯ ಕಾದಿದೆ - ಅದನ್ನು ಎರಡೂ ಕೈಗಳಿಂದ ಹಿಡಿಯಿರಿ!",
      successRate: "ಯಶಸ್ಸಿನ ಪ್ರಮಾಣ",
      happyStudents: "ಸಂತೋಷದ ವಿದ್ಯಾರ್ಥಿಗಳು",
      scholarshipsAwarded: "ವಿತರಣಾ ವಿದ್ಯಾರ್ಥಿವೇತನಗಳು",
      scholarshipProgram: "ಪೇಜ್ ವಿದ್ಯಾರ್ಥಿವೇತನ ಕಾರ್ಯಕ್ರಮ",
      whatScholarships: "ಯಾವ ವಿದ್ಯಾರ್ಥಿವೇತನಗಳು ಲಭ್ಯವಿವೆ?",
      howToApply: "ವಿದ್ಯಾರ್ಥಿವೇತನಗಳಿಗೆ ಅರ್ಜಿ ಸಲ್ಲಿಸುವುದು ಹೇಗೆ?",
      hearBack: "ನಾನು ಯಾವಾಗ ಮತ್ತೆ ಕೇಳುತ್ತೇನೆ?",
      checkStatus: "ನಾನು ನನ್ನ ಅರ್ಜಿಯ ಸ್ಥಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಬಹುದೇ?",
      needHelp: "ನನಗೆ ಸಹಾಯ ಬೇಕಾದರೆ ಏನು ಮಾಡಬಹುದು?",
      getInTouch: "ಈಗ ಸಂಪರ್ಕಿಸಿ!",
      namePlaceholder: "ಹೆಸರು",
      emailPlaceholder: "ಇಮೇಲ್",
      phonePlaceholder: "ದೂರವಾಣಿ",
      messagePlaceholder: "ಸಂದೇಶ",
      sendIt: "ಕಳುಹಿಸು",
      contactUs: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
      address: "ವಿಳಾಸ: ಪೇಜ್ ಇಂಡಸ್ಟ್ರಿಸ್ ಲಿಮಿಟೆಡ್, ಉಮಿಯಾ ಬಿಸಿನೆಸ್ ಬೇ - ಟವರ್ - 1, 7ನೇ ಮಹಡಿ, ಸೆಸ್ನಾ ಬಿಸಿನೆಸ್ ಪಾರ್ಕ್, ಕಡಬೆಸನಹಳ್ಳಿ, ವರ್ತೂರು ಹೋಬಳಿ, ಬೆಂಗಳೂರು- 560103.",
      phone: "ದೂರವಾಣಿ: 080-49454545 (ಮೊಬೈಲ್) / +91-6364455888",
      email: "ಇಮೇಲ್: PageScholarship.Support@jockeyindia.com",
      workingHours: "ಕೆಲಸದ ಸಮಯ: ಸೋ-ಶುಕ್ರವಾರ: ಬೆಳಿಗ್ಗೆ 9 - ಸಂಜೆ 5",
      footer: "ಪೇಜ್ ಇಂಡಸ್ಟ್ರಿಸ್ ಲಿಮಿಟೆಡ್. ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
      dontMiss: "ನಿಮ್ಮ ಅವಕಾಶವನ್ನು ಕೈಮೀರಿ!",
      chanceFunding: "ನಿಮ್ಮ ಕನಸುಗಳಿಗೆ ಹಣಕಾಸು ನೀಡುವ ಅವಕಾಶವನ್ನು ಇಂದು ಪಡೆಯಿರಿ!",
      coursesFor: "10 ನೇ ತರಗತಿಯಲ್ಲಿ ಉತ್ತೀರ್ಣರಾಗಿರುವ ಮತ್ತು ಆಕಾಂಕ್ಷಿಯಾಗಿರುವ ಅರ್ಹ ವಿದ್ಯಾರ್ಥಿಗಳನ್ನು ಬೆಂಬಲಿಸಿ",
      coursesListPre: "ಪಿಯುಸಿ (ವಿಜ್ಞಾನ, ಕಲೆ ಮತ್ತು ಮಾನವಿಕ, ವಾಣಿಜ್ಯ)",
      coursesListDip: "ಡಿಪ್ಲೊಮಾ (ಪಾಲಿಟೆಕ್ನಿಕ್)",
      coursesListITI: "ಐಟಿಐ",
      coursePara: "ಪ್ಯಾರಾ ಮೆಡಿಕಲ್",
      applyInstructions: "ಅರ್ಜಿಯನ್ನು ತುಂಬುವುದು ತುಂಬಾ ಸುಲಭ! ನಮ್ಮ ಆನ್‌ಲೈನ್ ಫಾರ್ಮ್ ತುಂಬಿಸಿ, ಸ್ವಲ್ಪ ಮಾಯಾವಿಸರಿ, ಮತ್ತು ಸಲ್ಲಿಸಿ. ಉಳಿದ ಎಲ್ಲವನ್ನು ನಾವು ನೋಡಿಕೊಳ್ಳುತ್ತೇವೆ!",
      hearBackInstructions: "ನೀವು ಕೆಲವು ವಾರಗಳಲ್ಲಿ ನವೀಕರಣಗಳನ್ನು ನಿರೀಕ್ಷಿಸಬಹುದು!!!",
      checkStatusInstructions: "ಖಂಡಿತವಾಗಿಯೂ! ಅರ್ಜಿಯ ಸ್ಥಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಲು ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಒಳಗಿನ ತಪಾಸಣಕಾರನನ್ನು ಬಿಡುಗಡೆ ಮಾಡಿ. ನಾವು ಎಲ್ಲವನ್ನೂ ಬಹಿರಂಗಪಡಿಸುತ್ತೇವೆ!",
      helpInstructions: "ಸಹಾಯ ಬೇಕೇ? ನಮ್ಮ ತಂಡ ಕೇವಲ ಒಂದು ಕ್ಲಿಕ್ ಅಂತರದಲ್ಲಿದೆ! ಸಂಪರ್ಕಿಸಿ, ವಿದ್ಯಾರ್ಥಿವೇತನಗಳ ಜಾಲದಲ್ಲಿ ನಾವು ನಿಮಗೆ ಮಾರ್ಗದರ್ಶನ ನೀಡುತ್ತೇವೆ.",
      home: "ಮನೆ",
      about: "ಕುರಿತು",
      apply: 'HOW TO APPLY',
      retreiveConsent: 'ಸಮ್ಮತಿಯನ್ನು ಹಿಂಪಡೆಯಿರಿ',
      faq: 'FAQ',
      PAGE_TnC_Privacy: 'T&C',
      PAGE_Privacy_Notice: 'PRIVACY_NOTICE',
      LastDateToApply: '“ಖಾಸಗಿ ಕಾಲೇಜುಗಳಿಗೆ ಪೇಜ್ ವಿದ್ಯಾರ್ಥಿವೇತನ ಆರಂಭವಾಗಿದೆ.”',
    },
  };

  const currentText = translations[language];

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'en' ? 'kn' : 'en'));
  };

  const toggleVisibility = (section: string) => {
    switch (section) {
      case "scholarship":
        setIsScholarshipOpen((prev) => !prev);
        break;
      case "apply":
        setIsApplyOpen((prev) => !prev);
        break;
      case "hearBack":
        setIsHearBackOpen((prev) => !prev);
        break;
      case "checkStatus":
        setIsCheckStatusOpen((prev) => !prev);
        break;
      case "needHelp":
        setIsNeedHelpOpen((prev) => !prev);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (event: { preventDefault: () => void; }) => {
    event.preventDefault();

    const mailtoLink = `mailto:PageScholarship.Support@jockeyindia.com?subject=Scholarship%20Application&body=Name:%20${name}%0AEmail:%20${email}%0APhone:%20${phone}%0AMessage:%20${message}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="app-container">

      <header className="header">
        <div className="header-content">
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? "×" : "☰"}
          </button>
          <div className="logo">
            <img src={logo} alt="Scholarship Program Logo" />
            <div className="logo-text">
              {/* <h1>{currentText.header}</h1> */}
              {/* <span>{currentText.headerSpan}</span> */}
            </div>
          </div>

          <nav className={`header-buttons ${menuOpen ? "open" : ""}`}>
            <button className="button" onClick={() => window.location.href = Scholarshiplink}>
              {currentText.applyNow}
            </button>
            <span className="separator">|</span>
            <button className="button" onClick={() => window.location.href = COLLEGELOGIN}>
              {currentText.RegisteredCollegeLogin}
            </button>
            <span className="separator">|</span>
            <button className="button" onClick={() => window.location.href = PRIVATESTUDENT}>
              {currentText.PrivateCollegeRegistration}
            </button>
            <span className="separator">|</span>
            <button className="button" onClick={() => window.location.href = ScholarshiplinkPriv}>
              {currentText.applyNowPrivate}
            </button>
            <span className="separator">|</span>

            <button className="button" onClick={() => window.location.href = applicationStatus}>{currentText.applicationStatus}</button>
            <span className="separator">|</span>

            {/* <div className="info-button-container">
              <button className="button" onClick={() => setDropdownOpen(!dropdownOpen)}>
                {currentText.info}
              </button>
              {dropdownOpen && (
                <div className="dropdown-menu">
                  <a href="/pdfs/How_to_fill_online_application_form.pdf" target="_blank" rel="noopener noreferrer">
                    {currentText.apply}
                  </a>
                  <a href="/pdfs/FAQs_English_and_Kannada.pdf" target="_blank" rel="noopener noreferrer">
                    {currentText.faq}
                  </a>
                  <a href="/pdfs/Privacy_Policy_and_Terms_and_Conditions_PAGE Scholarship.pdf" target="_blank" rel="noopener noreferrer">
                    {currentText.PAGE_TnC_Privacy}
                  </a>
                  <a href="/pdfs/Page_Industries_Privacy_Notice_for_PAGE_Scholarship.pdf" target="_blank" rel="noopener noreferrer">
                    {currentText.PAGE_Privacy_Notice}
                  </a>
                </div>
              )}
            </div> */}
            {/* <span className="separator">|</span> */}

            <button className="language-switcher-text" onClick={toggleLanguage}>
              🌐 {language === "en" ? "ಕನ್ನಡ" : "English"}
            </button>
          </nav>
        </div>
      </header>

      <main className="main">
        <section className="hero-new">

          {/* Scrolling Last Date Banner */}
          <div className="last-date-banner">
            <div className="scroll-text">{currentText.LastDateToApply}</div>
          </div>
          <div className="eligibility-image-container">
            <img src={privatecollege} alt="Eligibility" className="eligibility-image" />
          </div>
          <div className="hero-grid">

            {/* LEFT — ELIGIBILITY IMAGE */}
            {/* <div className="hero-box eligibility-box">
              <h2>Eligibility Criteria</h2>

              <div className="eligibility-image-container">
                <img src={img7} alt="Eligibility" className="eligibility-image" />
              </div>
            </div> */}



            {/* RIGHT — PDF LINKS */}
            <div className="hero-box docs-box">
              <h2>Important Documents</h2>

              <div className="pdf-card color-blue">
                <span>📘</span>
                <a href="/pdfs/BONAFIDE CERTIFICATE - ENGLISH and Kannada.pdf" target="_blank">Bonafide Certificate (PDF)</a>
              </div>

              <div className="pdf-card color-green">
                <span>📗</span>
                <a href="/pdfs/PARENTAL CONSENT FORM FOR SCHOLARSHIP APPLICATION.pdf" target="_blank">Parent Consent Form (PDF)</a>
              </div>

              <div className="pdf-card color-orange">
                <span>📙</span>
                <a href="/pdfs/Page Industries_Privacy Notice.pdf" target="_blank">Privacy Notice (PDF)</a>
              </div>

              <div className="pdf-card color-red">
                <span>📕</span>
                <a href="/pdfs/Privacy Policy and Terms and Conditions (Page Scholarship) - 7 Oct 2025 - Final.pdf" target="_blank">Privacy Policy (PDF)</a>
              </div>

              <div className="pdf-card color-yellow">
                <span>📒</span>
                <a href="/pdfs/PAGE Scholarship_25-26_15x21cm_English_1 2.pdf" target="_blank">Scholarship Details (PDF)</a>
              </div>

            </div>
          </div>
        </section>




        <section className="stats-container">
          {/*<div className="stat">
            <span className="stat-number">99%</span>
            <span className="stat-label">{currentText.successRate}</span>
          </div>*/}
          <div className="stat">
            <span className="stat-number">9,000+</span>
            <span className="stat-label">{currentText.happyStudents}</span>
          </div>
          <div className="stat">
            <span className="stat-number">10,000+</span>
            <span className="stat-label">{currentText.scholarshipsAwarded}</span>
          </div>
        </section>

        <section className="contact-section">
          <div className="contact-info">
            <h2>{currentText.contactUs}</h2>
            <p>{currentText.address}</p>
            <p>{currentText.phone}</p>
            <p>{currentText.email}</p>
            <p>{currentText.workingHours}</p>
          </div>
          <div className="map-container">
            <iframe
              src={mapLink}
              width="600"
              height="450"
              style={{ border: '0' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </section>
      </main>

      <footer className="footer">
        <ul className="footer-links">
          <li><a href="/">{currentText.home}</a></li>
          <li><a href="https://www.pageind.com/" target="_blank" rel="noopener noreferrer">{currentText.about}</a></li>
          <li>
            <a href={retreiveConsent}>{currentText.retreiveConsent}</a>
          </li>

          {/* <li><a href="/contact">Contact</a></li> */}
        </ul>
        <p>© {currentYear} {currentText.footer}</p>
      </footer>

    </div>
  );
}

export default App;
